import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const rangeFilter: ThemeUICSSObject = {
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  '.ApiaFilter__Range__Low': {
    'input:first-of-type': {
      textAlign: 'end',
    },
    'input:first-of-type::-webkit-inner-spin-button, input:first-of-type::-webkit-outer-spin-button':
      {
        WebkitAppearance: 'none',
        margin: 0,
      },
    'input[type=number]': {
      MozAppearance: 'textfield',
    },
  },
  '.ApiaFilter__Range__High': {
    'input:first-of-type::-webkit-inner-spin-button, input:first-of-type::-webkit-outer-spin-button':
      {
        WebkitAppearance: 'none',
        margin: 0,
      },
    'input[type=number]': {
      MozAppearance: 'textfield',
    },
  },
  'div:has(.ApiaFilter__Range__UnitSelector)': {
    flexShrink: 0,
    flexBasis: '80px',
  },
};

export default rangeFilter;
